<app-header></app-header>
<!-- <ng-container *ngFor="let language of languageList"> <a href="/{{language.code}}/"> <button class="button">{{language.label}}</button> </a></ng-container> -->

<router-outlet></router-outlet>
<app-footer></app-footer>
